import React from 'react';
import { faUsersRectangle } from '@fortawesome/free-solid-svg-icons';
import { FormGroup, Input } from 'reactstrap';
import { BaseFormViewModel } from '../common/ViewModel';
import {
    FormLabel,
    onFieldChange,
    onReactSelectChanged,
    toasty,
    ValidationErrorMessage,
    FormCheckbox,
} from '../common/forms/FormElements';
import CommonContext from '../Common';
import { ApiRoutes } from '../ApiRoutes';
import SlideForm from '../common/forms/SlideForm';
import { util } from '../Util';
import { handleFormSaveError } from '../common/forms/ValidationError';
import { Division } from './Division';
import { HexColorPicker } from 'react-colorful';
import LtsJobCard from '../longTermSchedule/LtsJobCard';

export default class DivisionForm extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);
        this.divisionForm = React.createRef();

        const stateBase = {
            division: new Division(),
            ...new BaseFormViewModel(),
        };

        this.state = stateBase;
        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);
        this.resetForm = this.resetForm.bind(this);
        this.isNew = this.isNew.bind(this);
        this.onSelectChanged = this.onSelectChanged.bind(this);
    }

    componentDidMount() {
        return this.populateState();
    }

    onChange = onFieldChange;
    onSelectChanged = onReactSelectChanged;

    handleSaveError = (err) => handleFormSaveError(this, err);

    onClose = () => {
        this.resetForm();
        this.props.toggleShow(false);
        this.context.setFormOpened(false);
        this.props.onClose();
    };

    onDelete = async (e) => {
        const { division } = this.state;

        const response = await util.fetch.delete(
            ApiRoutes.division.delete(division.id)
        );

        if (response) {
            this.onClose();
        }
    };

    onSelectChange = onReactSelectChanged;

    onSubmit = async (e) => {
        const { division } = this.state;

        this.setState({ errors: {}, saving: true });

        const url = this.isNew()
            ? ApiRoutes.division.create()
            : ApiRoutes.division.update();

        const response = await util.fetch
            .andGetResponse(util.fetch.types.post, url, division)
            .catch(this.handleSaveError);

        if (response) {
            this.onClose();
            toasty.success('Division Saved', 'Division saved successfully.');
        }
    };

    isNew = () => {
        const { division } = this.state;

        return Boolean(!division || !division.id || division.id <= 0);
    };

    openDivision = async (divisionId) => {
        await this.setState({ loading: true, division: new Division() });

        await this.populateState();

        if (divisionId > 0) {
            const division = await util.fetch.js(
                ApiRoutes.division.get(divisionId)
            );

            this.setState({ division });
        }

        this.setState({
            loading: false,
        });

        this.props.toggleShow(true);
        this.context.setFormOpened(true);
    };

    async populateState() {}

    resetForm = () => {
        this.setState({
            formValidated: false,
            division: new Division(),
        });
    };

    onColorChange = (colorHex) => {
        const { division } = this.state;

        division.colorHex = colorHex;

        this.setState({ division });
    };

    onInactiveChange = (e) => {
        const { division } = this.state;

        division.inactive = e.target.checked;

        this.setState({ division });
    };

    render() {
        const { formValidated, validationMessage, division, loading } =
            this.state;

        if (loading) {
            return null;
        }

        return (
            <SlideForm
                loading={this.state.loading}
                show={this.props.show}
                id="divisionForm"
                formIcon={faUsersRectangle}
                formTitle={this.isNew() ? 'Add Division' : 'Edit Division'}
                ref={this.formRef}
                setIsValidated={(formValidated) =>
                    this.setState({ formValidated })
                }
                isValidated={formValidated}
                onSubmit={this.onSubmit}
                onClose={this.onClose}
                onSave={this.onSave}
                onDelete={this.onDelete}
                errors={this.state.errors}
                onClearErrors={this.onClearErrors}
                validationMessage={validationMessage}
                entityId={division.id}
            >
                <FormGroup>
                    <FormLabel
                        htmlFor="division.name"
                        text="Name"
                        required={true}
                    />
                    <Input
                        id="division.name"
                        name="division.name"
                        value={division.name ?? ''}
                        onChange={this.onChange}
                        placeholder="Division Name"
                        type="text"
                        max={255}
                        maxLength={255}
                    />
                    <ValidationErrorMessage />
                </FormGroup>

                <FormGroup>
                    <FormLabel
                        htmlFor="division.inactive"
                        text="Inactive"
                        required={true}
                    />
                    <FormCheckbox
                        className="w-auto"
                        id="division.inactive"
                        name="division.inactive"
                        checked={division.inactive ?? ''}
                        onChange={this.onInactiveChange}
                        labelText="Inactive"
                    />
                    <ValidationErrorMessage />
                </FormGroup>

                <FormGroup>
                    <FormLabel htmlFor="division.colorHex" text="Color" />
                    <HexColorPicker
                        color={division.colorHex}
                        onChange={this.onColorChange}
                        className="mb-3"
                    />

                    <LtsJobCard
                        event={{
                            text: division.name,
                            divisionColorHex: division.colorHex,
                        }}
                    />
                </FormGroup>
            </SlideForm>
        );
    }
}
